/**
 * Utilitários para formatação de dados
 */

/**
 * Formata um CPF para o padrão brasileiro XXX.XXX.XXX-XX
 * @param cpf - CPF em formato string (com ou sem formatação)
 * @returns CPF formatado ou '-' se não fornecido
 */
export const formatCPF = (cpf: string): string => {
  if (!cpf) return '-';
  let cleanCPF = cpf.replace(/\D/g, '');

  if (cleanCPF.length === 12 && cleanCPF.startsWith('0')) {
    cleanCPF = cleanCPF.slice(1);
  }

  if (cleanCPF.length !== 11) return cpf;

  return cleanCPF.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
};

/**
 * Formata uma data para o padrão brasileiro DD/MM/AAAA
 * @param dateString - Data em formato string ou Date
 * @returns Data formatada ou '-' se não fornecida
 */
export const formatDate = (dateString: string | Date): string => {
  if (!dateString) return '-';

  if (typeof dateString === 'string') {
    const isoDateMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (isoDateMatch) {
      const [, year, month, day] = isoDateMatch;
      return new Date(Number(year), Number(month) - 1, Number(day)).toLocaleDateString('pt-BR');
    }
  }

  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return String(dateString);
  return date.toLocaleDateString('pt-BR');
};

/**
 * Formata um telefone para o padrão brasileiro (XX) XXXXX-XXXX
 * @param phone - Telefone em formato string (com ou sem formatação)
 * @returns Telefone formatado ou '-' se não fornecido
 */
export const formatPhone = (phone: string): string => {
  if (!phone) return '-';
  let cleanPhone = phone.replace(/\D/g, '');

  if ((cleanPhone.length === 12 || cleanPhone.length === 13) && cleanPhone.startsWith('55')) {
    cleanPhone = cleanPhone.slice(2);
  }
  
  if (cleanPhone.length === 11) {
    return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 7)}-${cleanPhone.slice(7)}`;
  } else if (cleanPhone.length === 10) {
    return `(${cleanPhone.slice(0, 2)}) ${cleanPhone.slice(2, 6)}-${cleanPhone.slice(6)}`;
  }
  
  return phone;
};

/**
 * Formata um CEP para o padrão brasileiro XXXXX-XXX
 * @param cep - CEP em formato string (com ou sem formatação)
 * @returns CEP formatado ou '-' se não fornecido
 */
export const formatCEP = (cep: string): string => {
  if (!cep) return '-';
  const cleanCEP = cep.replace(/\D/g, '');
  
  if (cleanCEP.length === 8) {
    return `${cleanCEP.slice(0, 5)}-${cleanCEP.slice(5)}`;
  }
  
  return cep;
};
